import firebase from 'firebase';


  var Config = {
    apiKey: "AIzaSyDC8BeeSpfa8o6IXEv7TnTvwf29D0a6L80",
    authDomain: "auth-a7736.firebaseapp.com",
    databaseURL: "https://auth-a7736.firebaseio.com",
    projectId: "auth-a7736",
    storageBucket: "auth-a7736.appspot.com",
    messagingSenderId: "91422776340",
    appId: "1:91422776340:web:b6a782b49211f3c9"
  };
var fire=firebase.initializeApp(Config)
export default fire;